import { render, staticRenderFns } from "./SfxVersions.vue?vue&type=template&id=fbaad6a0&scoped=true"
import script from "./SfxVersions.vue?vue&type=script&lang=js"
export * from "./SfxVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaad6a0",
  null
  
)

export default component.exports